import { FEATURE_KEYS } from "../constants";
import {
  DEFAULT_BLOCKED_MESSAGE,
  useQueryGetBlockedMessage,
} from "../data/services/portalSettingService";
import useAnyClientFeatureAccess from "./useAnyClientFeatureAccess";

/**
 * For client-list screens whose list came back empty: returns the admin-editable
 * blocked message when the user's clients are on the "blocked" list, otherwise
 * the given fallback text. The message is only fetched for blocked users.
 */
const useBlockedAwareMessage = (oePeriodId, fallbackMessage) => {
  const isBlocked = useAnyClientFeatureAccess(FEATURE_KEYS.Blocked, oePeriodId);
  const { data } = useQueryGetBlockedMessage(isBlocked);

  if (!isBlocked) {
    return fallbackMessage;
  }

  return data?.data?.message || DEFAULT_BLOCKED_MESSAGE;
};

export default useBlockedAwareMessage;
